import api from "./api";

export async function materialTagBatchDelete(tagIds: number[]) {
  const res = await api.post<unknown>('/material_tag/batch_delete', {
    tag_ids: tagIds,
  });
  return res.data;
}
